import { createSelector } from 'reselect'

export interface ClassicRewardCheckoutStatus {
  hasRewardFlights: boolean
  loading: boolean
  unavailable: boolean
  available: boolean
}

export interface ClassicRewardCheckoutView {
  classicRewards: Array<App.Checkout.ClassicRewardCheckoutState>
  totalPoints: number
  totalCash: number
  status: ClassicRewardCheckoutStatus
}

export const EMPTY_CLASSIC_REWARD_CHECKOUT_DATA: App.Checkout.ClassicRewardCheckoutPricing = {
  classicRewards: [],
  totalPoints: 0,
  totalCash: 0,
}

export const EMPTY_CLASSIC_REWARD_CHECKOUT_STATE: App.StatefulData<App.Checkout.ClassicRewardCheckoutPricing, 'unavailable'> = {
  fetching: false,
  data: EMPTY_CLASSIC_REWARD_CHECKOUT_DATA,
}

export function getCheckoutLoyaltyClassicRewardsState(
  state: App.State,
): App.StatefulData<App.Checkout.ClassicRewardCheckoutPricing, 'unavailable'> {
  return state.checkout.classicRewards ?? EMPTY_CLASSIC_REWARD_CHECKOUT_STATE
}

export const getCheckoutLoyaltyClassicRewardsView = createSelector(
  getCheckoutLoyaltyClassicRewardsState,
  (classicRewards): ClassicRewardCheckoutView => {
    const hasRewardFlights = classicRewards.fetching ||
      classicRewards.error === 'unavailable' ||
      !!classicRewards.data?.classicRewards.length

    return {
      ...(classicRewards.data ?? EMPTY_CLASSIC_REWARD_CHECKOUT_DATA),
      status: {
        hasRewardFlights,
        loading: !!classicRewards.fetching,
        unavailable: classicRewards.error === 'unavailable',
        available: !!classicRewards.data?.classicRewards.length,
      },
    }
  },
)

export function getCheckoutLoyaltyClassicRewards(
  state: App.State,
): Array<App.Checkout.ClassicRewardCheckoutState> {
  return getCheckoutLoyaltyClassicRewardsState(state).data?.classicRewards ?? EMPTY_CLASSIC_REWARD_CHECKOUT_DATA.classicRewards
}

export function getCheckoutLoyaltyClassicRewardsStatus(
  state: App.State,
): ClassicRewardCheckoutStatus {
  return getCheckoutLoyaltyClassicRewardsView(state).status
}
